// Shared helpers for the content-authoring forms (Batch 2/3).

// Title → URL slug. Lowercased, punctuation stripped, spaces collapsed to "-".
export const slugify = (text) =>
  (text || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");

// datetime-local ("2026-05-19T14:30") → RFC3339 UTC string for the API.
export const toRFC3339 = (local) => {
  if (!local) return undefined;
  const d = new Date(local);
  return Number.isNaN(d.getTime()) ? undefined : d.toISOString();
};

// RFC3339 → value for an <input type="datetime-local"> (local time, no zone).
export const toDateTimeLocal = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
    d.getHours()
  )}:${pad(d.getMinutes())}`;
};

// RFC3339 / date string → "YYYY-MM-DD" for an <input type="date">.
export const toDateInput = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

// "YYYY-MM-DD" → RFC3339 at midnight UTC, for date-only API fields.
export const dateToRFC3339 = (date) => {
  if (!date) return undefined;
  const d = new Date(`${date}T00:00:00Z`);
  return Number.isNaN(d.getTime()) ? undefined : d.toISOString();
};
